<template>
	<div class="px-4 sm:px-6 lg:px-6 py-6 bg-gray-100 flex-grow">
		<div class="flex justify-start">
			<img :src="auctionHammerUrl" class="w-16 h-16" />
			<h2 class="text-2xl font-medium text-gray-700 mb-8 ml-4">
				Jede Woche können Sie hier in Online-Auktionen auf Frei Fuhre Partien bieten. <br />
				<span v-if="auction !== null"
					>Die nächste Auktion startet am
					<span class="font-bold"
						>{{ auctionDay }}, den {{ auctionDate }} um {{ auctionTime }}</span
					>!</span
				>
			</h2>
		</div>

		<p class="text-2xl font-semibold text-orange mb-7 mt-2">
			So läuft unsere Auktion ab
		</p>

			<div class="flex justify-start">
				<div class="text-8xl font-bold text-orange-100 w-16 shrink-0">1</div>
				<div class="mt-4 ml-4 md:w-[60%]">
					<p class="mb-4"><strong>Bereitstellen</strong></p>
					<p class="mb-4">
						Jede Woche Mittwoch und Donnerstag haben Verkäufer die Möglichkeit ihre Ware mit einem verbindlichen Zielpreis in unserer Auktion bereitzustellen.
					</p>
				</div>
			</div>

			<div class="flex justify-start">
				<div class="text-8xl font-bold text-orange-100 w-16 shrink-0">2</div>
				<div class="mt-4 ml-4 md:w-[60%]">
					<p class="mb-4"><strong>Auktionseröffnung</strong></p>
					<p class="mb-4">
						Ab mittwochs bzw. donnerstags 14:30 Uhr können Sie die eingestellten Auktionsangebote einsehen und einen Kaufpreis für die für Sie interessanten Auktionsangebote kalkulieren.
					</p>
				</div>
			</div>

			<div class="flex justify-start">
				<div class="text-8xl font-bold text-orange-100 w-16 shrink-0">3</div>
				<div class="mt-4 ml-4 md:w-[60%]">
					<p class="mb-4"><strong>Bietverfahren</strong></p>
					<p class="mb-4">
						Um 15 Uhr startet das Bietverfahren nach dem Prinzip einer verdeckten Auktion. Sowohl die Zielpreise der Verkäufer als auch Gebote anderer Bieter sind für Sie nicht einsehbar. So erreichen wir ein möglichst unvoreingenommenes Bietverhalten aller Teilnehmer.
					</p>
					<p class="mb-4">
						Bis 16 Uhr können Sie Festpreis- oder prämienbasierte Gebote auf Ihre gewünschten Auktionsangebote abgeben.
					</p>
				</div>
			</div>

			<div class="flex justify-start">
				<div class="text-8xl font-bold text-orange-100 w-16 shrink-0">4</div>
				<div class="mt-4 ml-4 md:w-[60%]">
					<p class="mb-4"><strong>Auktionsende</strong></p>
					<p class="mb-4">
						Um 16 Uhr schließt das Bietverfahren und alle Gebote werden ausgewertet. Für Sie können sich folgende Ergebnisse ergeben:
					</p>
					<p class="mb-4">
						<strong>a)</strong> Wenn Sie als Käufer mindestens genau den Zielpreis für ein Angebot bieten, kommt es automatisch zu einem verbindlichen Kontrakt.
					</p>
					<p class="mb-4 text-gray-400">
						<strong>Beispiel:</strong> Der Zielpreis für 50 Tonnen war 230 €/t ab Hof und Sie haben in der Auktion als Höchstbietender 232 €/t geboten. Nach Ende der Auktion wird auf cropspot automatisch ein Kontrakt zu dem Ihnen gebotenen Preis, in dem Fall 232 €/t, geschlossen.
					</p>
					<p class="mb-4">
						<strong>b)</strong> Wenn Sie als Käufer der Höchstbietende für ein Angebot sind, aber nicht mindestens genau den Zielpreis bieten, erhält der Verkäufer zum Ende der Auktion nur von Ihnen ein Gebot auf cropspot mit Ihrem Preis.
					</p>
					<p class="mb-4 text-gray-400">
						<strong>Beispiel:</strong> Der Zielpreis für 50 Tonnen war 230 €/t ab Hof und Sie haben in der Auktion als Höchstbietender 228 €/t geboten. Der Verkäufer erhält nun lediglich von Ihnen ein 30 Minuten gültiges Angebot auf cropspot mit dem Preis von 228 €/t. Der Verkäufer kann so nochmal entscheiden, ob er das Angebot annimmt, ablehnt oder einen anderen Preis verhandeln will.
					</p>
				</div>
			</div>

	</div>
</template>

<script>
function padTo2Digits(num) {
	return num.toString().padStart(2, "0");
}
export default {
	props: {
		auction: {
			type: Object,
			required: false,
		},
	},
	computed: {
		auctionHammerUrl() {
			return window.baseUrl + "/images/auction-hammer.svg";
		},
		auctionDate() {
			var date = new Date(this.auction.bidding_starts_at);
			return (
				padTo2Digits(date.getDate()) +
				"." +
				padTo2Digits(date.getMonth() + 1) +
				"." +
				date.getFullYear()
			);
		},
		auctionTime() {
			var date = new Date(this.auction.bidding_starts_at);
			return (
				padTo2Digits(date.getHours()) + ":" + padTo2Digits(date.getMinutes())
			);
		},
		auctionDay() {
			var date = new Date(this.auction.bidding_starts_at);
			return date.toLocaleString("de-DE", { weekday: "long" });
		},
	},
	methods: {
		getBoxBackgroundCSS(color = "") {
			return (
				"background:url(" +
				window.baseUrl +
				"/images/auction-info-bubble-bg" +
				(color !== "" ? "-" + color : "") +
				".svg) bottom right no-repeat;"
			);
		},
	},
};
</script>
